import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const EXPIRATION_INFO_FRAGMENT = gql`
  fragment ExpirationInfoFragment on ExpirationInfoNode {
    id
    isExpired
    isOverridden
    isTrackingEnabled
    inheritedExpirationDate
    expirationDate
    computedFromEntity {
      ... on RegistryItemInterface {
        id
        name
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const FREEZE_THAW_INFO_FRAGMENT = gql`
  fragment FreezeThawInfoFragment on FreezeThawInfoNode {
    id
    isTrackingEnabled
    freezeThawCount
  }
`;

// TODO(BNCH-93708): Pull in only the necessary information for the component
export const CONTAINER_VIEW_QUERY = gql`
  query ContainerViewQuery($id: StrictString!) @skipAudit @engComponent(name: INVENTORY) {
    container(id: $id) {
      ... on ContainerNode {
        ...ContainerGraphQL
        parentStorable(skipAuthCheck: true) {
          ... on StorableInterface {
            ...StorableSummaryGraphQL
          }
          ...InaccessibleInfoGraphQL
        }
        expirationInfo {
          ...ExpirationInfoFragment
        }
        freezeThawInfo {
          ...FreezeThawInfoFragment
        }
      }
      ... on InaccessibleInfoNode {
        ...InaccessibleInfoGraphQL
      }
    }
  }
  ${getFragmentWrapper('Container').fragment}
  ${getFragmentWrapper('StorableSummary').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${EXPIRATION_INFO_FRAGMENT}
  ${FREEZE_THAW_INFO_FRAGMENT}
`;
